<template>
    <div></div>
</template>

<script>
    export default {
        name: "OptionTrigger",
        mounted() {
            this.$emit('loaded',true);
        }
    }
</script>
